import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const CloudCostIcon = (props) => (
  <SVG
    {...props}
    viewBox="0 0 16 16"
    css={css`
      fill: currentColor;
      stroke: currentColor;
      stroke-width: 0.25;
    `}
  >
    <path
      fillRule="evenodd"
      d="M13.125 0c0 1.678.197 1.875 1.875 1.875v.938c-1.678 0-1.875.196-1.875 1.874h-.938c0-1.678-.196-1.875-1.874-1.875v-.937c1.678 0 1.874-.197 1.874-1.875h.938zM9.218 7.975A2.155 2.155 0 009 7.912V7.05H8v.863a2.035 2.035 0 00-.845.412c-.277.231-.48.538-.563.887-.084.351-.04.714.12 1.037.16.32.422.58.74.756.316.176.68.267 1.048.267h.008c.203 0 .396.052.554.14.16.09.27.207.33.328a.523.523 0 01.043.36.663.663 0 01-.23.35 1.06 1.06 0 01-.504.221 1.223 1.223 0 01-.199.017h-.004c-.134 0-.267-.023-.39-.065a.926.926 0 01-.423-.285l-.313-.39-.78.625.313.39c.224.28.532.486.877.605.072.025.144.046.218.063v.862h1v-.862c.311-.072.603-.212.845-.413.277-.231.48-.537.563-.887.084-.35.04-.713-.12-1.036-.16-.321-.423-.58-.74-.757a2.162 2.162 0 00-1.048-.266h-.008a1.16 1.16 0 01-.554-.14.787.787 0 01-.33-.329.522.522 0 01-.044-.359.663.663 0 01.23-.35c.13-.108.304-.189.505-.222.2-.033.408-.015.592.048.185.064.33.168.424.285l.313.39.78-.625-.313-.39a1.924 1.924 0 00-.877-.605zM4.4 4C5.2 2.3 6.9 1 9 1v1C7.4 2 6 3 5.3 4.4l-.3.7S4.6 5 4 5C2.3 5 1 6.3 1 8s1.3 3 3 3h1v1H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h.4zm8.6 7a2 2 0 100-4V6a3 3 0 110 6h-1v-1h1z"
      clipRule="evenodd"
    />
  </SVG>
);

CloudCostIcon.propTypes = {
  size: PropTypes.string,
};

export default CloudCostIcon;
